import { render, staticRenderFns } from "./LiquidacionDetalle.vue?vue&type=template&id=03416a27&scoped=true&"
import script from "./LiquidacionDetalle.vue?vue&type=script&lang=js&"
export * from "./LiquidacionDetalle.vue?vue&type=script&lang=js&"
import style0 from "./LiquidacionDetalle.vue?vue&type=style&index=0&id=03416a27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03416a27",
  null
  
)

export default component.exports